import { LazoLogoWhite } from "@/components/utils/LazoLogo";
import { BoxProps, styled, SxProps, Theme } from "@mui/material";
import { Box } from "@mui/system";

const Banner = styled(Box)(({ theme }) => ({
  display: "none",
  zIndex: theme.zIndex.appBar,
  position: "absolute",
  width: "100%",
  height: "auto",
  background: "linear-gradient(285deg, #A16DFC 21.6%, #A146E9 98.56%)",
  padding: "1rem 0",
  justifyContent: "center",
  [theme.breakpoints.down("lg")]: {
    display: "flex",
  },
}));

/**
 * This banner only shows on mobile, put it somewhere inside the relevant component
 */
function MobileBanner({ containerProps, logoSx }: { containerProps?: BoxProps; logoSx?: SxProps<Theme> }) {
  return (
    <Banner {...containerProps}>
      <LazoLogoWhite sxClass={logoSx} />
    </Banner>
  );
}

export default MobileBanner;
